<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useVaultUploadDialog } from '@/composables/useVaultUploadDialog';

interface Props {
  files: File[];
}

const props = defineProps<Props>();

const emit = defineEmits<{
  done: [];
}>();

const router = useRouter();
const { openUploadDialog } = useVaultUploadDialog();

// On mount, let the user pick where the dropped file(s) go and upload them,
// then navigate to the signature-request page. That page prefills its
// documents from the `vault_file_uids` query param, so they arrive already
// selected. No type filter here: what a request accepts depends on the
// provider, which the wizard checks once one is chosen.
onMounted(async () => {
  if (props.files.length === 0) {
    emit('done');
    return;
  }

  try {
    const uploaded = await openUploadDialog({ files: props.files });
    if (!uploaded) return;
    await router.push({
      name: 'signing-request-new',
      query: { vault_file_uids: uploaded.map(({ fileUid }) => fileUid).join(',') },
    });
  } finally {
    emit('done');
  }
});
</script>

<template>
  <!-- headless: the upload dialog takes the files, then this navigates to the signature page -->
  <span style="display: none" />
</template>
